import { IEntry } from 'common/entities/courseWrapper/CourseWrapper';
import { Entity, Field } from 'typegraph';
import Product from 'panels/bundleEntries/entities/Product';
import CartItem from './CartItem';


@Entity({one: "cartDetails"})
export default class CartDetails{
    
    @Field()
    public total : number;

    @Field({entity: CartItem})
    public cartItems: CartItem[];

    @Field()
    public availableCredits : number;

    @Field()
    public remainingCredits : number; 
}





// WEBPACK FOOTER //
// ./src/panels/checkout/entities/CartDetails.ts